import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import type { EntryUpgradeType } from './upgrade-tag.types';
import {
  BidUpgradeType,
  UpgradeTagSize,
  UpgradeType,
} from './upgrade-tag.types';

@Component({
  selector: 'fl-upgrade-tag',
  template: `
    <ng-container [ngSwitch]="upgradeType">
      <ng-container
        *ngSwitchCase="UpgradeType.ASSISTED"
        i18n="Recruiter upgrade tag"
      >
        Recruiter
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.EXTENDED"
        i18n="Extended upgrade tag"
      >
        Extended
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.FEATURED"
        i18n="Featured upgrade tag"
      >
        Featured
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.FULL_TIME"
        i18n="Full Time upgrade tag"
      >
        Full Time
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.GUARANTEED"
        i18n="Guaranteed upgrade tag"
      >
        Guaranteed
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.HIGHLIGHT"
        i18n="Highlight upgrade tag"
      >
        Highlight
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.IP_AGREEMENT"
        i18n="IP Agreement upgrade tag"
      >
        IP Agreement
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.NDA"
        i18n="NDA upgrade tag"
      >
        NDA
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.PRIVATE"
        i18n="Private upgrade tag"
      >
        Private
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.TECHNICAL_COPILOT"
        i18n="Technical Co-pilot upgrade tag"
      >
        Technical Co-pilot
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.SEALED"
        i18n="Sealed upgrade tag"
      >
        Sealed
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.TOP_CONTEST"
        i18n="Top Contest upgrade tag"
      >
        Top Contest
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.CUSTOM_JUDGING"
        i18n="Custom Judging upgrade tag"
      >
        Custom Judging
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.URGENT"
        i18n="Urgent upgrade tag"
      >
        Urgent
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.QUALIFIED"
        i18n="Qualified upgrade tag"
      >
        Qualified
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.PREMIUM"
        i18n="Premium upgrade tag"
      >
        Premium
      </ng-container>
      <ng-container
        *ngSwitchCase="UpgradeType.ENTERPRISE"
        i18n="Enterprise upgrade tag"
      >
        Enterprise
      </ng-container>
      <ng-container
        *ngSwitchCase="BidUpgradeType.SPONSORED"
        i18n="Sponsored upgrade tag"
      >
        Sponsored
      </ng-container>
    </ng-container>
  `,
  styleUrls: ['./upgrade-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeTagComponent {
  BidUpgradeType = BidUpgradeType;
  UpgradeType = UpgradeType;

  @HostBinding('attr.data-upgrade-type')
  @Input()
  upgradeType: UpgradeType | BidUpgradeType | EntryUpgradeType;

  @HostBinding('attr.data-size')
  @Input()
  size: UpgradeTagSize = UpgradeTagSize.MID;
}
